"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Label_1 = __importDefault(require("./styledComponents/Label"));

var DocumentLabel_1 = __importDefault(require("./styledComponents/DocumentLabel"));

var DocumentDownloadList_meta_1 = require("./DocumentDownloadList.meta");

var List_1 = __importDefault(require("../../base/List"));

var Checkbox_1 = __importDefault(require("../../base/Checkbox"));

var mobx_1 = require("mobx");

var DocumentDownload_1 = require("../DocumentDownload/DocumentDownload");

var Translate_1 = __importDefault(require("../../base/Translate"));

var DocumentDownloadList =
/** @class */
function (_super) {
  __extends(DocumentDownloadList, _super);

  function DocumentDownloadList(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = DocumentDownloadList_meta_1.DOCUMENT_DOWNLOAD_LIST_CATEGORY_KEY;
    _this.componentKey = DocumentDownloadList_meta_1.DOCUMENT_DOWNLOAD_LIST_COMPONENT_KEY;

    _this.handleGroupedItemToggle = function (documents) {
      var checkboxValue = _this.getGroupedCheckboxValue(documents);

      if (checkboxValue === true) {
        documents = _this.setDocumentsSelectedValue(documents, false);
      }

      if (checkboxValue === false || checkboxValue === 'half') {
        documents = _this.setDocumentsSelectedValue(documents, true);
      }
    };

    _this.setDocumentsSelectedValue = function (documents, selected) {
      for (var _i = 0, documents_1 = documents; _i < documents_1.length; _i++) {
        var document_1 = documents_1[_i];
        document_1.selected = selected;
      }

      return documents;
    };

    _this.getGroupedCheckboxValue = function (documents) {
      var checkboxValue = false;

      if (documents && documents.length > 0) {
        if (documents.length === 1) {
          checkboxValue = !!documents[0].selected;
        } else {
          var trueValues = 0;
          var falseValues = 0;

          for (var _i = 0, documents_2 = documents; _i < documents_2.length; _i++) {
            var document_2 = documents_2[_i];

            if (document_2.selected) {
              trueValues++;
            } else {
              falseValues++;
            }
          }

          if (trueValues === documents.length) {
            checkboxValue = true;
          }

          if (trueValues !== 0 && falseValues !== 0) {
            checkboxValue = 'half';
          }
        }
      }

      return checkboxValue;
    };

    return _this;
  }

  Object.defineProperty(DocumentDownloadList.prototype, "groupedDocumentItems", {
    get: function get() {
      var _this = this;

      var _a = this.props,
          _b = _a.groupedDocuments,
          groupedDocuments = _b === void 0 ? [] : _b,
          onItemToggle = _a.onItemToggle,
          onDownloadClick = _a.onDownloadClick,
          allowSelection = _a.allowSelection,
          showPill = _a.showPill,
          hideLabel = _a.hideLabel,
          dropdownLabelType = _a.dropdownLabelType,
          pillProps = _a.pillProps,
          showCopyButton = _a.showCopyButton,
          copyButtonProps = _a.copyButtonProps,
          useSpinner = _a.useSpinner;
      var breakpoints = this.breakpoints;
      var response = [];

      var _loop_1 = function _loop_1(groupedDocument) {
        var label = groupedDocument.label,
            documents = groupedDocument.documents;
        var describedById = ksys_app_template_1.utils.guid.generateGuid();
        var documentLabel = void 0;

        if (allowSelection) {
          var value = this_1.getGroupedCheckboxValue(documents);
          documentLabel = react_1.default.createElement(Checkbox_1.default, {
            labelId: describedById,
            label: label,
            value: value,
            onChange: function onChange() {
              return _this.handleGroupedItemToggle(documents);
            }
          });
        } else {
          documentLabel = react_1.default.createElement(Label_1.default, {
            id: describedById
          }, react_1.default.createElement(Translate_1.default, null, label));
        }

        var documentDownloadProps = {
          breakpoints: breakpoints,
          onItemToggle: onItemToggle,
          onDownloadClick: onDownloadClick,
          documents: documents,
          allowSelection: allowSelection,
          showPill: showPill,
          hideLabel: hideLabel,
          dropdownLabelType: dropdownLabelType,
          pillProps: pillProps,
          useSpinner: useSpinner,
          describedById: describedById,
          showCopyButton: showCopyButton,
          copyButtonProps: copyButtonProps,
          availableLabel: groupedDocument.availableLabel,
          selectionLabel: groupedDocument.selectionLabel,
          ariaLabelPrefix: label
        };
        var element = [react_1.default.createElement(DocumentLabel_1.default, null, documentLabel), react_1.default.createElement(DocumentDownload_1.DocumentDownload, __assign({}, documentDownloadProps))];
        response.push(element);
      };

      var this_1 = this;

      for (var _i = 0, groupedDocuments_1 = groupedDocuments; _i < groupedDocuments_1.length; _i++) {
        var groupedDocument = groupedDocuments_1[_i];

        _loop_1(groupedDocument);
      }

      return response;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DocumentDownloadList.prototype, "hasDocuments", {
    get: function get() {
      var groupedDocuments = this.props.groupedDocuments;
      return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(groupedDocuments);
    },
    enumerable: true,
    configurable: true
  });

  DocumentDownloadList.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        heading = _a.heading,
        hideWhenEmpty = _a.hideWhenEmpty;

    if (!this.hasDocuments && hideWhenEmpty) {
      return null;
    }

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(List_1.default, {
      heading: heading,
      items: this.groupedDocumentItems,
      itemStyle: 'justified'
    }));
  };

  __decorate([mobx_1.action], DocumentDownloadList.prototype, "handleGroupedItemToggle", void 0);

  __decorate([mobx_1.action], DocumentDownloadList.prototype, "setDocumentsSelectedValue", void 0);

  __decorate([mobx_1.computed], DocumentDownloadList.prototype, "groupedDocumentItems", null);

  DocumentDownloadList = __decorate([mobx_react_1.observer], DocumentDownloadList);
  return DocumentDownloadList;
}(shared_1.ResponsiveComponentBase);

exports.DocumentDownloadList = DocumentDownloadList;
exports.default = shared_1.InjectedStyledComponent(DocumentDownloadList, DocumentDownloadList_meta_1.DOCUMENT_DOWNLOAD_LIST_CATEGORY_KEY, DocumentDownloadList_meta_1.DOCUMENT_DOWNLOAD_LIST_COMPONENT_KEY);